// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invalid-element[data-v-50967ba1] {
  border: 1px dashed currentColor;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/SharedWeb/scripts/dynamic-component-editor/standard-elements/InvalidElement.vue","webpack://./InvalidElement.vue"],"names":[],"mappings":"AAEA;EACE,+BAAA;EACA,YAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.invalid-element {\n  border: 1px dashed currentColor;\n  opacity: 0.7;\n}\n",".invalid-element {\n  border: 1px dashed currentColor;\n  opacity: 0.7;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
